// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel___kTyG","info":"Panel_info__1aZ1E","btns":"Panel_btns__1D7So","button":"Panel_button__1obGk"};